// extracted by mini-css-extract-plugin
module.exports = {"icons":"storyPageMetaDataIcons-m__icons__3E4Xg","print-link":"storyPageMetaDataIcons-m__print-link__2ZSiR","share-button":"storyPageMetaDataIcons-m__share-button__1NXgK"};